<template>
  <div class="container-fluid">
    <div id="loading-screen" v-show="isLoading">
    <div class="fancy-loader">
      <span>LOADING</span>
      <svg xmlns="http://www.w3.org/2000/svg" class="lds-comets" width="250px" height="250px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="rotate(162.228 50 50)">
      <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" values="360 50 50;240 50 50;120 50 50;0 50 50" keyTimes="0;0.333;0.667;1" dur="1s" keySplines="0.7 0 0.3 1;0.7 0 0.3 1;0.7 0 0.3 1" calcMode="spline"/>
      <path fill="#41918E" d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"/>
      <path fill="#E0E0E0" d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"/>
      <path fill="#80CBC4" d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"/></g>
      </svg>
    </div>
 
  </div>
  
     <div class="row">
    <div class="col-xs-4 col-md-12">
      <div v-tooltip.right="'Back to platform'" class="back-to-car-icon" @click="navigateToCentralAnalytics">
        <v-icon class="back-to-car-icon-v" style="color:white;">arrow_back</v-icon>
      </div>
    </div>
  </div>

    <div class="row">
      <div class="col-xs-12 col-md-12" style="padding:15px;">
        <h1 id="top_of_page" class="update_title">Update</h1>
        <h5 class="update_subtitle">
          The MSDAT platform is updated regularly to ensure optimum experience
          and data quality.
        </h5>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-md-12">
        <div class="item" v-bind:class="{'list_short': wrapperClick}">
         <div id="timeline" class="timeline">
           <section class="entry">
             <div class="left">
               <p class="date">October 30th, 2019</p>
             </div>

             <div class="right">
               <h3 class="right__title">Version 1.3 Updates (Performance Improvement)</h3>
               <h4 class="right__subtitle">Features</h4>
               <p>The following features were introduced in version 1.3 of the MSDAT platform:</p>
               <ul class="list">
                 <li>Indicator Overview with related indicators</li>
                 <li>Indicator Trend analysis across data sources</li>
                 <li>Comparison of selected Indicator and related indicators across data sources (Routine, Surveys, Estimate)</li>
                 <li>Indicator distribution by states and LGAs</li>
                 <li>Indicator definitions and meta-data</li>
                 <li>Geopolitical zonal analysis of Indicator</li>
                 <li>Multi-Source Indicator Comparison</li>
                 <li>Multi-Dataset Comparison of Indicator by states</li>
                 <li>MSDAT Onboarding & Tour guide</li>
                 <li>Data Download in multiple formats</li>
                 <li>Share dashboard feature</li>
                 <li>Mobile responsive view</li>
                 <li>Feedback tool</li>
                 <li>Offline web capabilities</li>
                 <li>Submit data source feature</li>
                 <li>Date Last Updated on dashboard footer </li>
                 <li>Automatic cache-clearing for browser after 30 days</li>
                 <li>Automatic browser caches clearing if page doesn’t load after 30 seconds</li>
                 <li>MSDAT Contact page </li>
                 <li>MSDAT About page with information on available data</li>
                 <li>Contact form pop-up </li>
                 <li>Unsupported browser pop-up alert</li>
                 <li>GZip compression enabled </li>
               </ul>

               <h4 class="right__subtitle">Data Updates</h4>
               <p>The following data updates were made in version 1.3 of the MSDAT platform:</p>
               <ul class="list">
                 <li>32 Indicators across 17 data sources and 6 program areas: RMNCH, Malaria, Immunization, Nutrition, Mortality & HIV</li>
                 <li>National & SDG Targets added where applicable</li>
                 <li>Confidence range values added where applicable</li>
               </ul>
             </div>
           </section>
         </div>
        </div>
      </div>
      <div
        class="col-xs-12 col-md-12 col-xs-offset-4"
        style="padding-top:25px;padding-bottom:80px; color:white"
      >
        <button
          class="btn btn-more"
          @click="wrapperClicked"
        >
          {{ wrapperClick ? "Show More" : "Show Less" }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isloading: false,
      wrapperClick: true
    };
  },
  methods: {
    navigateToCentralAnalytics() {
      this.isLoading = true;
      setTimeout(() => {
        this.$router.push("central_analytics");
      }, 1000);
    },
    wrapperClicked() {
      this.wrapperClick = !this.wrapperClick;
    }
  }
};
</script>
<style lang="scss" scoped>


body {
  font-family: Open Sans;
}

.list_short{
  height: 500px !important;
}

.update_title {
  text-align: center;
  font-size: 31px;
  font-weight: 900;
  letter-spacing: 0;
  color: #232323;
  opacity: 1;
  margin-top: 20px;
}

.update_subtitle {
  font-weight: 600 !important;
  font-size: 15px;
  text-align: center;
  letter-spacing: 0;
  color: #232323;
  opacity: 1; 
}

.item {
  display: flex;
  flex: auto;
  overflow-y: hidden;
}

.timeline {
  position: relative;
  display: table; 
  margin: {
    left: 0;
    right: auto;
    top: 3.5rem;
  }
  &:before {
    content: '';
    position: absolute;
    top: 5px;
    bottom: 0;
    left: 27%;
    width: 2px;
    background: #ddd;
  }
  &:after {
    content: "";
    display: table;
    clear: both;
  } 
}

.entry {
  clear: both;
  text-align: left;
  position: relative;
  
  .left {
    margin-bottom: .5em;
    float: left;
    width: 25%;
    padding-right: 5px;
    position: relative;
    &:before {
      content: '';
      position: absolute;
      border: 8px solid #007D53;
      border-radius:100%;
      top: 15%;
      right: -11%;
      z-index: 99;
    }
  }
}

.date {
    text-align: right;
    letter-spacing: 0;
    color: #171717;
    opacity: 1;
    font-weight:600; 
    font-size:14px;
    }

.right {
    margin: 0 0 3em;
    float: right;
    width: 71%;
    line-height: .4;
    ul {
      padding-left: 0;
      list-style-type: none;
      li:before {
        content: "–";
        margin-right: .3em;
      }
    }
  }

  .list {
    margin-left: -1px;
    padding-top:0;
  }

  .list li {
    text-align: left;
    font-size: 16px;
    letter-spacing: 0;
    color: #171717;
    font-weight: 500;
    opacity: 1;
  }

  .right__title{
    text-align: left;
    font-size: 20px;
    letter-spacing: 0;
    color: #007D53;
    font-weight: 700;
    opacity: 1;
  }

  .right__subtitle {
    text-align: left;
    font-size:  16.5px;
    letter-spacing: 0;
    font-weight: 600;
    color: #515151;
    opacity: 1;
  }

  .btn-more{
    background-color:#007D53!important; 
    color:white !important; 
    border-color: #007D53 !important;
    position: absolute;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.4);
    width:127.5px; 
    height:41px;
    left: -15.5%;
  }

@media screen and (max-width: 769px) {
  .list-short {
    max-height: 450px !important;
  }

  #timeline {
    margin: auto;
  }

  .left {
    p {
    font-size: 10px;
    padding-right: 0;
    line-height: 16px;
  }  
  }

  .right {
    line-height: 18px;
  }
}

@media screen and (max-width: 426px) {
  .left {
     &:before {
       right: -19% !important;
    }
  
  }

  .date {
    text-align: left;
    }

    .right {
    width: 67%;
    }

   .btn-more{
    left: 3%;
  }

}

@media screen  and (min-width:424px ) and (max-width: 770px){
  .left {
     &:before {
       right: -16.5% !important;
    }
  
  }
}

@media screen  and (min-width:768px ) and (max-width: 1023px){
  .left {
     &:before {
       right: -12.5% !important;
    }
  }

  .btn-more{
    left: 1%;
  }
}

@media screen  and (min-width:1024px ) and (max-width: 1053px){

  .btn-more{
    left: 1%;
  }
}

@media screen  and (min-width:1054px ) and (max-width: 1698px){

  .btn-more{
    left: 4%;
  }
}


.back-to-car-icon{
  color:white !important;
  top:105px;
  cursor:pointer;
}
@media only screen and (max-width: 600px) {
div.back-to-car-icon {
    top:140px
}
}

</style>



// WEBPACK FOOTER //
// updateLog.vue?269f5e68